import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { mapContentToNotification } from 'src/app/notifications/mappings/notification-mapping-helper';
import { NotificationHandlerService } from 'src/app/notifications/notification-handler.service';
import { NotificationContentBase, NotificationDto, NotificationService, NotificationSettingsDto } from 'src/app/services/api.services';
import { ManageProfileData, ManageProfileDialog } from 'src/app/shared/dialogs';
import { isInternalUrl } from 'src/app/shared/helpers/url-helper';

@Component({
  selector: 'app-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrls: ['./notification-menu.component.scss'],
  standalone: false
})
export class NotificationMenuComponent implements OnInit, OnChanges, OnDestroy{
  constructor(
    private notificationService: NotificationService,
    private notificationHandlerService: NotificationHandlerService,
    private store: Store,
    private changeDetectionRef: ChangeDetectorRef,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnDestroy(): void {
    this.notifObservable.unsubscribe();
  }

  ngOnInit(): void {
    this.menuTrigger.onMenuOpen.subscribe(() => { this.selectedNotification = null; }); 

    this.notifObservable = this.notificationHandlerService
      .notificationsObservable
      .pipe(filter(s => !!s && !this.updateLocked))
      .subscribe((notifs) => {
        this.loadNotifications(notifs);
        if (this.notificationHandlerService != null)
          this.loading = false;
      });


  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.notificationSettings)
      this.loadNotifications(this.rawNotifs)
  }


  loading = true;
  updateLocked = false;
  showPending = false;
  notifications: NotifListItem[];
  pendingNotifications: NotifListItem[];
  rawNotifs: NotificationDto[] = [];

  notifObservable: Subscription;

  selectedNotification: NotifListItem;

  @Input() disabled: boolean;
  @Input() notificationSettings: NotificationSettingsDto;
  @Input() menuTrigger: MatMenuTrigger;

  loadNotifications(notifs: NotificationDto[]) {
    this.rawNotifs = notifs;

    if (this.disabled) {
      this.notifications = [];
      this.pendingNotifications = [];
      return;
    }

    let enabledCategorys = this.notificationSettings.sections
      .filter(s => s.panelEnabled == true)
      .map(s => s.category)

    let activNotifs = notifs.filter(n => n.pending == false && enabledCategorys.includes(n.category));
      let pendingNotifs = notifs.filter(n => n.pending == true && enabledCategorys.includes(n.category));

      this.notifications = activNotifs
        .sort((a, b) => Date.parse(b.timeCreated) - Date.parse(a.timeCreated))
        .map(n => <NotifListItem>{id: n.id, content: mapContentToNotification(n.content, n.timeCreated), time: n.timeCreated });

      this.pendingNotifications = pendingNotifs
        .sort((a, b) => Date.parse(b.timeCreated) - Date.parse(a.timeCreated))
        .map(n => <NotifListItem>{id: n.id, content: mapContentToNotification(n.content, n.timeCreated), time: n.timeRequested });

      this.changeDetectionRef.markForCheck();
  }

  formatTime(date: string): string {
    let minutes = moment(moment()).diff(date, 'minutes');
    if (minutes < 60)
      return `${minutes}m`;

    let hours = moment(moment()).diff(date, 'hours');
    return `${hours}h`;
  }

  navigateToLink(url: string) {
    if (isInternalUrl(url)) {
      this.router.navigateByUrl(url);
    } else {
      window.location.href = url;
    }

    this.menuTrigger.closeMenu();
  }

  dismissNotification(id: number, pending: boolean) {
    if (!pending) {
      if (this.notifications.length < 1)
        return;

      let notif = this.notifications.find(n => n.id == id);
      let index = this.notifications.indexOf(notif);
      this.notifications.splice(index,1);
    } else {
     if (this.pendingNotifications.length < 1)
        return;

      let notif = this.pendingNotifications.find(n => n.id == id);
      let index = this.pendingNotifications.indexOf(notif);
      this.pendingNotifications.splice(index,1);
    }
    this.updateLocked = true;
    this.notificationService.clearNotification(id).subscribe(()=> this.updateLocked = false);
  }

  dismissAllNotification() {
    if (this.disabled)
      return;

    this.updateLocked = true;

    if (this.showPending) {
      this.notificationService.clearPendingNotifications().subscribe(()=> this.updateLocked = false);
      this.pendingNotifications = [];
    }
    else {
      this.notificationService.clearActiveNotifications().subscribe(()=> this.updateLocked = false);
      this.notifications = [];
    }
  }

  manageProfile() {
    this.dialog.open<ManageProfileDialog, ManageProfileData>(ManageProfileDialog, {
      width: '985px',
      minHeight: '600px',
      data: { tab: 2 }
    });
  }
}

interface NotifListItem { id: number ,content: NotificationContentBase, time: string; }
